import { render, staticRenderFns } from "./vpd-select.vue?vue&type=template&id=dd958326&scoped=true"
import script from "./vpd-select.vue?vue&type=script&lang=js"
export * from "./vpd-select.vue?vue&type=script&lang=js"
import style0 from "./vpd-select.vue?vue&type=style&index=0&id=dd958326&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd958326",
  null
  
)

export default component.exports